"use client";

import React from "react";
import { PageShell } from "@/components/templates/PageShell";
import { ProcessWorkflowTemplate } from "@/components/templates/ProcessWorkflowTemplate";

export default function HowWeWorkPage() {
  return (
    <PageShell>
      {(openOrderModal) => (
        <ProcessWorkflowTemplate
          breadcrumbs={[
            { label: "Как заказать" },
          ]}
          badgeText="Порядок сотрудничества"
          title="Как мы работаем: от заявки до сдачи объекта"
          description="Понятный регламент взаимодействия без скрытых доплат. Личный технолог сопровождает проект от первого звонка до подписания закрывающих актов."
          steps={[
            {
              step: "01",
              title: "Заявка и предварительная консультация",
              duration: "15–30 минут",
              desc: "Вы оставляете заявку на сайте или звоните нам. Менеджер уточняет тип продукции, тираж, желаемые сроки и адрес объекта.",
              deliverable: "Ориентировочная смета",
            },
            {
              step: "02",
              title: "Замер и проверка макетов",
              duration: "1 рабочий день",
              desc: "Инженер выезжает на объект для замера параметров или дизайнер бесплатно проверяет присланный файл на соответствие техническим нормам.",
              deliverable: "Техническое задание и чертежи",
            },
            {
              step: "03",
              title: "Договор и фиксация стоимости",
              duration: "1–2 часа",
              desc: "Заключаем официальный договор с фиксированной сметой, сроками сдачи и гарантией. Выставляем счет для безналичной оплаты.",
              deliverable: "Подписанный договор и спецификация",
            },
            {
              step: "04",
              title: "Производство на собственном оборудовании",
              duration: "от 1 до 5 дней",
              desc: "Запуск тиража в цехе: широкоформатная печать, ЧПУ-фрезеровка, лазерная резка, сборка и калибровка электрики.",
              deliverable: "Готовая продукция с контролем ОТК",
            },
            {
              step: "05",
              title: "Доставка или профессиональный монтаж",
              duration: "В назначенный день",
              desc: "Бережно упаковываем изделия, доставляем собственным транспортом по Сыктывкару или проводим монтажные работы на высоте.",
              deliverable: "Установленная конструкция",
            },
            {
              step: "06",
              title: "Приемка и выдача гарантии",
              duration: "15 минут",
              desc: "Проверяем работоспособность подсветки и качество печати вместе с заказчиком, подписываем закрывающие документы ЭДО или на бумаге.",
              deliverable: "Акты и гарантийный талон",
            },
          ]}
          paymentMethods={[
            {
              title: "Безналичный расчет для юридических лиц",
              desc: "Работаем с НДС 20% и без НДС. Предоставляем полный комплект закрывающих бухгалтерских документов через Диадок, СБИС или на бумаге.",
            },
            {
              title: "Поэтапная оплата 50/50",
              desc: "Для крупных и производственных заказов действует стандартная схема: 50% предоплата перед закупкой материалов, 50% после сдачи работы.",
            },
            {
              title: "Оплата для физических лиц",
              desc: "Банковские карты любых банков, оплата по QR-коду через СБП с моментальной фискализацией и выдачей онлайн-чека.",
            },
          ]}
          guarantees={[
            {
              title: "Письменная гарантия качества",
              desc: "Официальный гарантийный талон: от 12 до 24 месяцев на рекламные конструкции и электрику. Бесплатный выезд мастера при гарантийном случае.",
            },
            {
              title: "Собственная служба доставки",
              desc: "Специально оборудованный грузовой транспорт с пирамидами для перевозки широкоформатных планшетов, стекол и композитных коробов.",
            },
            {
              title: "Соблюдение сроков договора",
              desc: "Фиксируем финальную дату в календарном графике договора. Несем материальную ответственность за каждый день просрочки.",
            },
          ]}
          faqItems={[
            {
              q: "Можно ли запустить заказ без готового макета?",
              a: "Да, в нашем штате работают 3 профессиональных графических дизайнера. Мы разработаем дизайн с нуля по вашему описанию или доработаем существующие исходники.",
            },
            {
              q: "Работаете ли вы по Республике Коми за пределами Сыктывкара?",
              a: "Да, мы регулярно отправляем продукцию транспортными компаниями и выполняем выездные монтажные работы в Ухте, Воркуте, Печоре и других городах республики.",
            },
            {
              q: "Есть ли срочное изготовление полиграфии или баннеров?",
              a: "Да, для тиражей визиток, баннеров и наклеек доступна услуга «Экспресс-печать» с готовностью день в день при наличии готового макета.",
            },
          ]}
          onOpenOrderModal={openOrderModal}
        />
      )}
    </PageShell>
  );
}

